
export const isViewportGreaterThan = ({ pixels }) => window.innerWidth > pixels;
